import React, { Fragment, useEffect } from 'react';
import SEO from '../../components/SEO/SEO';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import PricingSection from '../../components/ai-chatbot-components/PricingSection/PricingSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import pricingBg from '../../images/bg/pricing-bg.png';

const PricingPage: React.FC = () => {
  return (
    <Fragment>
      <SEO title="Pricing" description="AXOIX pricing plans — Explorer Vessel (Free Forever), Officer Cruiser, Command Battleship, and Titan Mothership. Start free, scale as you grow. All plans include SEAL e-signatures and REMEDY complaints." path="/pricing" />
      <div className="pricing-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main
            style={{
              backgroundImage: `url(${pricingBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center top",
              backgroundRepeat: "no-repeat",
              backgroundAttachment: "fixed",
            }}
          >
            <PageTitle
              pageTitle="Pricing Plans"
              pagesub="Choose Your Plan"
            />
            <PricingSection hideBg />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default PricingPage;
